import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    // 基地址
    // baseUrl: 'http://cangduobao.com',
    baseUrl:'http://cangduobao.com',
    // 语言标识
    lang: 0,
    // 分类状态标识
    sort: false,
    // 供应商id
    admin_id: null,
    // 用户名
    userName: '',
    // 用户token
    token: '',
    // 用户id
    user_id: null,
    // 首页、产品中心等等状态切换
    indexPage: 0,
    // 返回首页标识
    showHome: false,
    // 凭证
    voucher: '',
    // 留言条数
    message: null,
    // 留言的id
    messageIds: [],
    // 用户头像
    usericon: '',
    sortList: [],
    moreSortList: [],
    // 购物车数据
    carList: [],
    xiangData:{logo:''}
  },
  getters: {},
  mutations: {
    setXiang(state, data) {
      state.xiangData = data
    },
    // 语言切换
    changeLang(state, lang) {
      state.lang = lang
    },
    // 修改admin_id
    changeAdmin_id(state, admin_id) {
      state.admin_id = admin_id
    },
    // 存储token
    changeToken(state, token) {
      state.token = token
    },
    // 存储用户名
    changeUserName(state, userName) {
      console.log(userName, 'userName')
      state.userName = userName
    },
    // 更改分类状态方法
    changeSort(state, sort) {
      state.sort = sort
    },
    // 更改首页、产品中心等等状态
    changeIndexPage(state, page) {
      state.indexPage = page
    },
    // 更改用户登录id
    changeUserId(state, id) {
      state.user_id = id
    },
    // 更改返回首页标识
    changeShowHome(state, showHome) {
      state.showHome = showHome
    },
    // 修改凭证
    changevoucher(state, voucher) {
      state.voucher = voucher
    },
    // 修改留言条数
    changeMessage(state, message) {
      state.message = message
    },
    changeMessageIds(state, mes) {
      state.messageIds = mes
    },
    ids(state, ids) {
      state.messageIds.forEach((item, index) => {
        if (item == ids) {
          state.messageIds.splice(index, 1)
        }
      })
    },
    // 修改用户头像
    changeuserIcon(state, icon) {
      state.usericon = icon
    },
    changemoreSortList(state, a) {
      state.moreSortList = a
    },
    changesortList(state, a) {
      state.sortList = a
    },
    changeCarList(state, a) {
      state.carList = a
    }
  },
  actions: {},
  modules: {},
  // 配置vuex的插件
  plugins: [createPersistedState()]
})
